import { EmailSubscriptionsRow } from './EmailSubscriptionsRow';
import { DailyOpsRunsTable } from './DailyOpsRunsTable';

export function DailyOperationsReportsCard() {
  return (
    <div className="bg-ems-bg-card border border-ems-border rounded-lg p-4 space-y-4">
      <div>
        <h2 className="text-base font-semibold text-ems-text-primary">Daily Operations Reports</h2>
        <p className="text-sm text-ems-text-muted">
          Operations PDFs generated each morning at 06:15 site-local time. Opt in below to receive the report by email.
        </p>
      </div>
      <EmailSubscriptionsRow />
      <DailyOpsRunsTable />
    </div>
  );
}
